import React from 'react';
import { Overlay } from 'app/components/BlurredOverlay';
import MenuDishesProvider from 'app/containers/MenuDishesProvider';
import MobileFilters from '../MobileFiltersNew/MobileFilters';


// const basketQueryForFilters = deliveryId ? deliveryBasketQuery : basketQuery;
// if (!selectedFilters.selectedPeriod || !selectedFilters.selectedCategoryId) return null;
// if (!basketQueryForFilters.cart) return null;

export const MobileFiltersWrapper = React.memo((props) => {
    const {
        showMobileFiltersOverlay,
        handleCloseMobileFilters,
        handleMobileFiltersStartApplying,
        showDeliveryMenu,
    } = props;
    return (
        <div>
            <Overlay
                overlayOpen={showMobileFiltersOverlay}
                animateEnter
                animateExit
                onClick={handleCloseMobileFilters}
                animationDirection="right"
                render={() => (
                    <MenuDishesProvider
                        wrapper="MobileFiltersWrapper => MobileFilters"
                        render={(dishesProps) => (
                            <MobileFilters
                                {...dishesProps}
                                isNeededRenderPeriod={!showDeliveryMenu}
                                isNeededRenderSubscription={!showDeliveryMenu}
                                onClose={handleCloseMobileFilters}
                                onStartApplying={handleMobileFiltersStartApplying}
                            />
                        )
                        }
                    />
                )
                }
            />
        </div>
    );
});
